import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { shortDate } from "LIB/formatters/date";
import { getFirstNameLastInitial, truncate } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";
import { NoteTooltipTableCell } from "MODULES/shared/components/NoteTooltip";
import {
  DataTable,
  SearchPropTypes,
  CompanyName,
  LinkedTableRow
} from "MODULES/shared/components";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";

function renderRow(lineItem, i) {
  const handleMailto = e => {
    e.stopPropagation();
  };

  return (
    <LinkedTableRow to={`/lots/${lineItem.lot.uuid}`} key={i}>
      <td>
        <div style={{ whiteSpace: "nowrap" }}>
          <div style={{ textAlign: "right" }}>{i + 1}</div>
        </div>
      </td>
      <td>{lineItem.lot.code}</td>
      <td> {shortDate(lineItem.created_at)}</td>
      <td>
        <CompanyName company={lineItem.company} />
      </td>
      <td>{getFirstNameLastInitial(lineItem.buyer.full_name)}</td>
      <td>
        {lineItem.co_buyer &&
          getFirstNameLastInitial(lineItem.co_buyer.full_name)}
      </td>
      <td>{lineItem.serial_number || lineItem.expected_serial_number}</td>
      <td>{truncate(lineItem.contact.name, 25)}</td>
      <td>
        <a href={`mailto:${lineItem.contact.email}`} onClick={handleMailto}>
          {lineItem.contact.email}
        </a>
      </td>
      <td>
        {INCOMING_LINE_ITEMS.condition[lineItem.condition].abbrev}
        <AsIsFlag lineItem={lineItem} className="m-l-5" />
      </td>
      <td>{lineItem.quantity}</td>
      <td className="text-center">{lineItem.quantity_received}</td>
      <td>{lineItem.lead_time}</td>

      <td className="text-right">{dollars(lineItem.cost)}</td>
      <NoteTooltipTableCell note={lineItem.internal_note} />
    </LinkedTableRow>
  );
}

export function Table(props) {
  const { pushHistory, isLoading, results } = props;

  return (
    <DataTable loading={isLoading} numbered>
      <DataTable.Head>
        <th />
        <th>PO #</th>
        <th>Date Created</th>
        <th>Vendor</th>
        <th>Buyer</th>
        <th>Co-Buyer</th>
        <th>Serial #</th>
        <th>Contact</th>
        <th>Email</th>
        <th>CD</th>
        <th>QTY</th>
        <th className="text-center">QTY Rec</th>
        <th>LT</th>
        <th className="text-right">Cost Ea</th>
        <th />
      </DataTable.Head>
      <DataTable.Body>
        {results.map((r, i) => renderRow(r, i, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/parts/components/LotLineItems/Table.jsx